import React from 'react';
import { Link, browserHistory } from 'react-router';

const Tabs = ({ tabs, id, level }) => {
  // Set Level for each iterated item to enforce authorization

  function authmap(tab, i) {
    if (level >= tab.level) {
      return (
        <li key={`${tab.url}${i}`} className="tab col s3" onClick={() => browserHistory.push(tab.url)}>
          <Link className="tab-text" to={`${tab.url}`}>{tab.name}</Link>
        </li>
      )
    }
    return;
  }

  return (
    <div className="row">
      <ul id={id} className="tabs tabs-fixed-width">
        { tabs.map(authmap) }
      </ul>
    </div>
  );
};

export default Tabs;



// WEBPACK FOOTER //
// ./src/components/tabs.js